module.exports = "/images/file-icon.svg?38a3ef34e8b48670027d0f1892621637";